module.exports = __webpack_public_path__ + "img/gfqg-logo-primary.59772f49.svg";